// extracted by mini-css-extract-plugin
export default {"container":"FullViewportWidth_container__lh7nA"};